import React from 'react'
import { ReactComponent as IconoCheck } from "assets/icons/Check.svg"
import { Button } from "reactstrap"

type PropsButton = {
    text: string,
    onClick?: () => void,
    disabled?:boolean,
    [key: string]: any;
}


export default function ButtonAprobarMasivo(props: PropsButton) {
    const { onClick,disabled} = props
    const classNameDisabled = disabled !== undefined && disabled === true ? " disabled":""

    if(onClick !== undefined){
        return (
            <div className={'containerBtnAprobarMasivo'+ classNameDisabled} onClick={() => onClick()}>
                <IconoCheck id={"CheckAprobarMasivo"} className={classNameDisabled}  />
                <div className={'containerTextApMas'+ classNameDisabled}>
                    {props.text}
                </div>
            </div>
        )
    }
    else {
        return (
            <div className={'containerBtnAprobarMasivo'+ classNameDisabled}>
                <IconoCheck id={"CheckAprobarMasivo"} className={classNameDisabled}  />
                <div className={'containerTextApMas'+ classNameDisabled}>
                    {props.text}
                </div>
            </div>
        )
    }
    
}
